export default __webpack_public_path__ + "static/media/iconCornerChair.47b9873d.svg";